// RoofCertificateFlorida.com — programmatic city + service + carrier registry.
// SEO Takeover Phases 1-2: Expanded from 53 → 130+ FL cities, 3 → 6 services.
// Each combination renders at /{service}/{citySlug} on the RCF subdomain.

export interface RcfCity {
  slug: string;
  name: string;
  county: string;
  region: "Southeast" | "Southwest" | "Central West" | "Central" | "North" | "Panhandle" | "Treasure Coast" | "Space Coast" | "Keys";
  /** Major insurance carriers most active in the area, used in copy */
  topCarriers?: string[];
  /** Famous neighborhoods / landmarks for hyper-local content */
  neighborhoods?: string[];
  /** Average roof age band that drives demand for certifications */
  roofProfile?: string;
}

export const RCF_CITIES: RcfCity[] = [
  // ───────── Southeast — Palm Beach ─────────
  { slug: "boca-raton", name: "Boca Raton", county: "Palm Beach County", region: "Southeast", topCarriers: ["Citizens", "Universal", "Tower Hill"], neighborhoods: ["Royal Palm Yacht Club", "Boca Pointe", "Mizner Park"], roofProfile: "Tile and concrete tile, 12–22 yrs avg" },
  { slug: "delray-beach", name: "Delray Beach", county: "Palm Beach County", region: "Southeast", topCarriers: ["Citizens", "Heritage", "Florida Peninsula"], neighborhoods: ["Lake Ida", "Atlantic Avenue", "Seagate"] },
  { slug: "boynton-beach", name: "Boynton Beach", county: "Palm Beach County", region: "Southeast", topCarriers: ["Citizens", "Universal", "American Integrity"] },
  { slug: "jupiter", name: "Jupiter", county: "Palm Beach County", region: "Southeast", topCarriers: ["Citizens", "Tower Hill"] },
  { slug: "palm-beach-gardens", name: "Palm Beach Gardens", county: "Palm Beach County", region: "Southeast" },
  { slug: "wellington", name: "Wellington", county: "Palm Beach County", region: "Southeast" },
  { slug: "west-palm-beach", name: "West Palm Beach", county: "Palm Beach County", region: "Southeast", topCarriers: ["Citizens", "Heritage"] },
  { slug: "lake-worth-beach", name: "Lake Worth Beach", county: "Palm Beach County", region: "Southeast" },
  { slug: "royal-palm-beach", name: "Royal Palm Beach", county: "Palm Beach County", region: "Southeast" },
  { slug: "greenacres", name: "Greenacres", county: "Palm Beach County", region: "Southeast" },
  { slug: "palm-beach", name: "Palm Beach", county: "Palm Beach County", region: "Southeast", topCarriers: ["Citizens", "Tower Hill"] },
  { slug: "lake-park", name: "Lake Park", county: "Palm Beach County", region: "Southeast" },
  { slug: "north-palm-beach", name: "North Palm Beach", county: "Palm Beach County", region: "Southeast" },
  { slug: "tequesta", name: "Tequesta", county: "Palm Beach County", region: "Southeast" },
  { slug: "lantana", name: "Lantana", county: "Palm Beach County", region: "Southeast" },
  { slug: "loxahatchee", name: "Loxahatchee", county: "Palm Beach County", region: "Southeast" },
  { slug: "belle-glade", name: "Belle Glade", county: "Palm Beach County", region: "Southeast" },

  // ───────── Southeast — Broward ─────────
  { slug: "fort-lauderdale", name: "Fort Lauderdale", county: "Broward County", region: "Southeast", topCarriers: ["Citizens", "Universal", "Slide"], neighborhoods: ["Las Olas", "Coral Ridge", "Victoria Park"] },
  { slug: "hollywood", name: "Hollywood", county: "Broward County", region: "Southeast" },
  { slug: "pompano-beach", name: "Pompano Beach", county: "Broward County", region: "Southeast" },
  { slug: "coral-springs", name: "Coral Springs", county: "Broward County", region: "Southeast" },
  { slug: "pembroke-pines", name: "Pembroke Pines", county: "Broward County", region: "Southeast" },
  { slug: "plantation", name: "Plantation", county: "Broward County", region: "Southeast" },
  { slug: "sunrise", name: "Sunrise", county: "Broward County", region: "Southeast" },
  { slug: "davie", name: "Davie", county: "Broward County", region: "Southeast" },
  { slug: "miramar", name: "Miramar", county: "Broward County", region: "Southeast" },
  { slug: "weston", name: "Weston", county: "Broward County", region: "Southeast" },
  { slug: "deerfield-beach", name: "Deerfield Beach", county: "Broward County", region: "Southeast" },
  { slug: "tamarac", name: "Tamarac", county: "Broward County", region: "Southeast" },
  { slug: "margate", name: "Margate", county: "Broward County", region: "Southeast" },
  { slug: "coconut-creek", name: "Coconut Creek", county: "Broward County", region: "Southeast" },
  { slug: "parkland", name: "Parkland", county: "Broward County", region: "Southeast" },
  { slug: "lauderhill", name: "Lauderhill", county: "Broward County", region: "Southeast" },
  { slug: "lauderdale-lakes", name: "Lauderdale Lakes", county: "Broward County", region: "Southeast" },
  { slug: "oakland-park", name: "Oakland Park", county: "Broward County", region: "Southeast" },
  { slug: "wilton-manors", name: "Wilton Manors", county: "Broward County", region: "Southeast" },
  { slug: "cooper-city", name: "Cooper City", county: "Broward County", region: "Southeast" },
  { slug: "dania-beach", name: "Dania Beach", county: "Broward County", region: "Southeast" },
  { slug: "hallandale-beach", name: "Hallandale Beach", county: "Broward County", region: "Southeast" },

  // ───────── Southeast — Miami-Dade ─────────
  { slug: "miami", name: "Miami", county: "Miami-Dade County", region: "Southeast", topCarriers: ["Citizens", "Universal", "Slide"] },
  { slug: "miami-beach", name: "Miami Beach", county: "Miami-Dade County", region: "Southeast" },
  { slug: "coral-gables", name: "Coral Gables", county: "Miami-Dade County", region: "Southeast" },
  { slug: "doral", name: "Doral", county: "Miami-Dade County", region: "Southeast" },
  { slug: "homestead", name: "Homestead", county: "Miami-Dade County", region: "Southeast" },
  { slug: "kendall", name: "Kendall", county: "Miami-Dade County", region: "Southeast" },
  { slug: "aventura", name: "Aventura", county: "Miami-Dade County", region: "Southeast" },
  { slug: "hialeah", name: "Hialeah", county: "Miami-Dade County", region: "Southeast" },
  { slug: "north-miami", name: "North Miami", county: "Miami-Dade County", region: "Southeast" },
  { slug: "north-miami-beach", name: "North Miami Beach", county: "Miami-Dade County", region: "Southeast" },
  { slug: "miami-gardens", name: "Miami Gardens", county: "Miami-Dade County", region: "Southeast" },
  { slug: "cutler-bay", name: "Cutler Bay", county: "Miami-Dade County", region: "Southeast" },
  { slug: "palmetto-bay", name: "Palmetto Bay", county: "Miami-Dade County", region: "Southeast" },
  { slug: "pinecrest", name: "Pinecrest", county: "Miami-Dade County", region: "Southeast" },
  { slug: "key-biscayne", name: "Key Biscayne", county: "Miami-Dade County", region: "Southeast" },
  { slug: "sunny-isles-beach", name: "Sunny Isles Beach", county: "Miami-Dade County", region: "Southeast" },
  { slug: "south-miami", name: "South Miami", county: "Miami-Dade County", region: "Southeast" },

  // ───────── Southwest ─────────
  { slug: "naples", name: "Naples", county: "Collier County", region: "Southwest", topCarriers: ["Citizens", "Heritage", "American Integrity"], neighborhoods: ["Pelican Bay", "Park Shore", "Old Naples"] },
  { slug: "marco-island", name: "Marco Island", county: "Collier County", region: "Southwest" },
  { slug: "immokalee", name: "Immokalee", county: "Collier County", region: "Southwest" },
  { slug: "ave-maria", name: "Ave Maria", county: "Collier County", region: "Southwest" },
  { slug: "golden-gate", name: "Golden Gate", county: "Collier County", region: "Southwest" },
  { slug: "bonita-springs", name: "Bonita Springs", county: "Lee County", region: "Southwest" },
  { slug: "estero", name: "Estero", county: "Lee County", region: "Southwest" },
  { slug: "fort-myers", name: "Fort Myers", county: "Lee County", region: "Southwest", topCarriers: ["Citizens", "Universal", "Tower Hill"] },
  { slug: "fort-myers-beach", name: "Fort Myers Beach", county: "Lee County", region: "Southwest" },
  { slug: "cape-coral", name: "Cape Coral", county: "Lee County", region: "Southwest" },
  { slug: "lehigh-acres", name: "Lehigh Acres", county: "Lee County", region: "Southwest" },
  { slug: "sanibel", name: "Sanibel", county: "Lee County", region: "Southwest" },
  { slug: "punta-gorda", name: "Punta Gorda", county: "Charlotte County", region: "Southwest" },
  { slug: "port-charlotte", name: "Port Charlotte", county: "Charlotte County", region: "Southwest" },
  { slug: "englewood", name: "Englewood", county: "Charlotte County", region: "Southwest" },
  { slug: "north-port", name: "North Port", county: "Sarasota County", region: "Southwest", topCarriers: ["Citizens", "Heritage", "American Integrity"] },
  { slug: "venice", name: "Venice", county: "Sarasota County", region: "Southwest" },
  { slug: "nokomis", name: "Nokomis", county: "Sarasota County", region: "Southwest" },
  { slug: "osprey", name: "Osprey", county: "Sarasota County", region: "Southwest" },

  // ───────── Central West ─────────
  { slug: "sarasota", name: "Sarasota", county: "Sarasota County", region: "Central West" },
  { slug: "siesta-key", name: "Siesta Key", county: "Sarasota County", region: "Central West" },
  { slug: "longboat-key", name: "Longboat Key", county: "Sarasota County", region: "Central West" },
  { slug: "bradenton", name: "Bradenton", county: "Manatee County", region: "Central West" },
  { slug: "lakewood-ranch", name: "Lakewood Ranch", county: "Manatee County", region: "Central West" },
  { slug: "palmetto", name: "Palmetto", county: "Manatee County", region: "Central West" },
  { slug: "anna-maria", name: "Anna Maria", county: "Manatee County", region: "Central West" },
  { slug: "tampa", name: "Tampa", county: "Hillsborough County", region: "Central West", topCarriers: ["Citizens", "Heritage", "Slide"] },
  { slug: "st-petersburg", name: "St. Petersburg", county: "Pinellas County", region: "Central West" },
  { slug: "clearwater", name: "Clearwater", county: "Pinellas County", region: "Central West" },
  { slug: "largo", name: "Largo", county: "Pinellas County", region: "Central West" },
  { slug: "pinellas-park", name: "Pinellas Park", county: "Pinellas County", region: "Central West" },
  { slug: "palm-harbor", name: "Palm Harbor", county: "Pinellas County", region: "Central West" },
  { slug: "dunedin", name: "Dunedin", county: "Pinellas County", region: "Central West" },
  { slug: "tarpon-springs", name: "Tarpon Springs", county: "Pinellas County", region: "Central West" },
  { slug: "brandon", name: "Brandon", county: "Hillsborough County", region: "Central West" },
  { slug: "riverview", name: "Riverview", county: "Hillsborough County", region: "Central West" },
  { slug: "valrico", name: "Valrico", county: "Hillsborough County", region: "Central West" },
  { slug: "plant-city", name: "Plant City", county: "Hillsborough County", region: "Central West" },
  { slug: "wesley-chapel", name: "Wesley Chapel", county: "Pasco County", region: "Central West" },
  { slug: "new-port-richey", name: "New Port Richey", county: "Pasco County", region: "Central West" },
  { slug: "land-o-lakes", name: "Land O' Lakes", county: "Pasco County", region: "Central West" },
  { slug: "spring-hill", name: "Spring Hill", county: "Hernando County", region: "Central West" },
  { slug: "brooksville", name: "Brooksville", county: "Hernando County", region: "Central West" },

  // ───────── Central ─────────
  { slug: "orlando", name: "Orlando", county: "Orange County", region: "Central", topCarriers: ["Citizens", "Heritage", "Universal"] },
  { slug: "winter-park", name: "Winter Park", county: "Orange County", region: "Central" },
  { slug: "winter-garden", name: "Winter Garden", county: "Orange County", region: "Central" },
  { slug: "apopka", name: "Apopka", county: "Orange County", region: "Central" },
  { slug: "ocoee", name: "Ocoee", county: "Orange County", region: "Central" },
  { slug: "kissimmee", name: "Kissimmee", county: "Osceola County", region: "Central" },
  { slug: "st-cloud", name: "St. Cloud", county: "Osceola County", region: "Central" },
  { slug: "celebration", name: "Celebration", county: "Osceola County", region: "Central" },
  { slug: "lakeland", name: "Lakeland", county: "Polk County", region: "Central" },
  { slug: "winter-haven", name: "Winter Haven", county: "Polk County", region: "Central" },
  { slug: "lake-wales", name: "Lake Wales", county: "Polk County", region: "Central" },
  { slug: "davenport", name: "Davenport", county: "Polk County", region: "Central" },
  { slug: "haines-city", name: "Haines City", county: "Polk County", region: "Central" },
  { slug: "ocala", name: "Ocala", county: "Marion County", region: "Central" },
  { slug: "the-villages", name: "The Villages", county: "Sumter County", region: "Central" },
  { slug: "leesburg", name: "Leesburg", county: "Lake County", region: "Central" },
  { slug: "clermont", name: "Clermont", county: "Lake County", region: "Central" },
  { slug: "mount-dora", name: "Mount Dora", county: "Lake County", region: "Central" },
  { slug: "deland", name: "DeLand", county: "Volusia County", region: "Central" },
  { slug: "deltona", name: "Deltona", county: "Volusia County", region: "Central" },
  { slug: "sanford", name: "Sanford", county: "Seminole County", region: "Central" },
  { slug: "altamonte-springs", name: "Altamonte Springs", county: "Seminole County", region: "Central" },
  { slug: "oviedo", name: "Oviedo", county: "Seminole County", region: "Central" },
  { slug: "lake-mary", name: "Lake Mary", county: "Seminole County", region: "Central" },

  // ───────── Treasure Coast ─────────
  { slug: "stuart", name: "Stuart", county: "Martin County", region: "Treasure Coast", topCarriers: ["Citizens", "Tower Hill"] },
  { slug: "palm-city", name: "Palm City", county: "Martin County", region: "Treasure Coast" },
  { slug: "hobe-sound", name: "Hobe Sound", county: "Martin County", region: "Treasure Coast" },
  { slug: "port-st-lucie", name: "Port St. Lucie", county: "St. Lucie County", region: "Treasure Coast" },
  { slug: "fort-pierce", name: "Fort Pierce", county: "St. Lucie County", region: "Treasure Coast" },
  { slug: "vero-beach", name: "Vero Beach", county: "Indian River County", region: "Treasure Coast" },
  { slug: "sebastian", name: "Sebastian", county: "Indian River County", region: "Treasure Coast" },
  { slug: "okeechobee", name: "Okeechobee", county: "Okeechobee County", region: "Treasure Coast" },

  // ───────── Space Coast ─────────
  { slug: "melbourne", name: "Melbourne", county: "Brevard County", region: "Space Coast" },
  { slug: "palm-bay", name: "Palm Bay", county: "Brevard County", region: "Space Coast" },
  { slug: "titusville", name: "Titusville", county: "Brevard County", region: "Space Coast" },
  { slug: "cocoa", name: "Cocoa", county: "Brevard County", region: "Space Coast" },
  { slug: "cocoa-beach", name: "Cocoa Beach", county: "Brevard County", region: "Space Coast" },
  { slug: "merritt-island", name: "Merritt Island", county: "Brevard County", region: "Space Coast" },
  { slug: "satellite-beach", name: "Satellite Beach", county: "Brevard County", region: "Space Coast" },
  { slug: "rockledge", name: "Rockledge", county: "Brevard County", region: "Space Coast" },

  // ───────── North ─────────
  { slug: "jacksonville", name: "Jacksonville", county: "Duval County", region: "North", topCarriers: ["Citizens", "Universal", "Heritage"] },
  { slug: "jacksonville-beach", name: "Jacksonville Beach", county: "Duval County", region: "North" },
  { slug: "atlantic-beach", name: "Atlantic Beach", county: "Duval County", region: "North" },
  { slug: "neptune-beach", name: "Neptune Beach", county: "Duval County", region: "North" },
  { slug: "st-augustine", name: "St. Augustine", county: "St. Johns County", region: "North" },
  { slug: "st-johns", name: "St. Johns", county: "St. Johns County", region: "North" },
  { slug: "ponte-vedra-beach", name: "Ponte Vedra Beach", county: "St. Johns County", region: "North" },
  { slug: "fernandina-beach", name: "Fernandina Beach", county: "Nassau County", region: "North" },
  { slug: "yulee", name: "Yulee", county: "Nassau County", region: "North" },
  { slug: "orange-park", name: "Orange Park", county: "Clay County", region: "North" },
  { slug: "fleming-island", name: "Fleming Island", county: "Clay County", region: "North" },
  { slug: "middleburg", name: "Middleburg", county: "Clay County", region: "North" },
  { slug: "gainesville", name: "Gainesville", county: "Alachua County", region: "North" },
  { slug: "lake-city", name: "Lake City", county: "Columbia County", region: "North" },
  { slug: "daytona-beach", name: "Daytona Beach", county: "Volusia County", region: "North" },
  { slug: "ormond-beach", name: "Ormond Beach", county: "Volusia County", region: "North" },
  { slug: "new-smyrna-beach", name: "New Smyrna Beach", county: "Volusia County", region: "North" },
  { slug: "port-orange", name: "Port Orange", county: "Volusia County", region: "North" },
  { slug: "palm-coast", name: "Palm Coast", county: "Flagler County", region: "North" },

  // ───────── Panhandle ─────────
  { slug: "tallahassee", name: "Tallahassee", county: "Leon County", region: "Panhandle" },
  { slug: "pensacola", name: "Pensacola", county: "Escambia County", region: "Panhandle" },
  { slug: "panama-city", name: "Panama City", county: "Bay County", region: "Panhandle" },
  { slug: "panama-city-beach", name: "Panama City Beach", county: "Bay County", region: "Panhandle" },
  { slug: "destin", name: "Destin", county: "Okaloosa County", region: "Panhandle" },
  { slug: "fort-walton-beach", name: "Fort Walton Beach", county: "Okaloosa County", region: "Panhandle" },
  { slug: "navarre", name: "Navarre", county: "Santa Rosa County", region: "Panhandle" },
  { slug: "milton", name: "Milton", county: "Santa Rosa County", region: "Panhandle" },
  { slug: "crestview", name: "Crestview", county: "Okaloosa County", region: "Panhandle" },

  // ───────── Keys ─────────
  { slug: "key-west", name: "Key West", county: "Monroe County", region: "Keys" },
  { slug: "marathon", name: "Marathon", county: "Monroe County", region: "Keys" },
  { slug: "key-largo", name: "Key Largo", county: "Monroe County", region: "Keys" },
  { slug: "islamorada", name: "Islamorada", county: "Monroe County", region: "Keys" },
];

// ───────── Services ─────────
export const RCF_SERVICES = [
  {
    slug: "roof-condition-certificate",
    name: "Roof Condition Certificate",
    shortName: "Roof Certificate",
    description: "Carrier-accepted roof condition report required for Florida homeowners insurance renewal.",
    form: "Roof Condition Certification Form",
    benefits: [
      "Required by Citizens, Universal, Heritage, Tower Hill and most FL carriers",
      "Documents roof age, material, and remaining useful life",
      "Issued within 24–48 hours of inspection",
    ],
  },
  {
    slug: "wind-mitigation",
    name: "Wind Mitigation Inspection",
    shortName: "Wind Mitigation",
    description: "OIR-B1-1802 wind mitigation report — unlocks state-mandated insurance discounts of 20–45%.",
    form: "OIR-B1-1802",
    benefits: [
      "Unlocks Florida-mandated wind premium discounts (avg. $500–$1,200/yr saved)",
      "Documents roof-to-wall connection, deck attachment, opening protection",
      "Valid for 5 years per FL statute 627.711",
    ],
  },
  {
    slug: "4-point-inspection",
    name: "4-Point Inspection",
    shortName: "4-Point",
    description: "Standard 4-point inspection (roof, electrical, plumbing, HVAC) required by most Florida insurers for homes 25+ years old.",
    form: "Citizens 4-Point or carrier-equivalent",
    benefits: [
      "Required for homes 25+ years on most FL policies",
      "Includes roof condition assessment",
      "Same-day report turnaround available",
    ],
  },
  {
    slug: "roof-age-verification",
    name: "Roof Age Verification",
    shortName: "Roof Age",
    description: "Permit-pulled roof age verification letter — required when carriers can't confirm install date from public records.",
    form: "Permit History + Contractor Affidavit",
    benefits: [
      "Resolves carrier disputes over reported roof age",
      "Pulled from county permit office and signed by licensed contractor",
      "Often delivered the same business day",
    ],
  },
  {
    slug: "insurance-recertification",
    name: "Insurance Recertification",
    shortName: "Recertification",
    description: "Re-issued roof certificate after repair work — keeps your Florida policy bound when carriers request a new report mid-cycle.",
    form: "Updated Roof Condition Certification",
    benefits: [
      "Avoids non-renewal after carrier requests an updated report",
      "Documents completed repairs (flashings, sealants, replaced shingles)",
      "Submitted directly to your agent for binding",
    ],
  },
  {
    slug: "hip-roof-affidavit",
    name: "Hip Roof Affidavit",
    shortName: "Hip Roof Affidavit",
    description: "Sworn hip-roof shape verification — qualifies your home for the largest single FL wind mitigation discount.",
    form: "OIR-B1-1802 (Section 3)",
    benefits: [
      "Unlocks the largest individual wind mitigation premium discount",
      "Sworn statement by a Florida-licensed contractor",
      "Works in tandem with full wind mitigation report",
    ],
  },
] as const;

export type RcfServiceSlug = typeof RCF_SERVICES[number]["slug"];

export const findRcfCity = (slug: string) => RCF_CITIES.find(c => c.slug === slug);
export const findRcfService = (slug: string) => RCF_SERVICES.find(s => s.slug === slug);

// ───────── Counties (for /county/:county hub) ─────────
export const RCF_COUNTIES = Array.from(
  new Set(RCF_CITIES.map(c => c.county))
).map(county => ({
  slug: county.toLowerCase().replace(/\s+/g, "-").replace(/\./g, ""),
  name: county,
  cities: RCF_CITIES.filter(c => c.county === county),
}));

export const findRcfCounty = (slug: string) =>
  RCF_COUNTIES.find(c => c.slug === slug);

// ───────── Carriers (for /carrier/:carrier hub) ─────────
export interface RcfCarrier {
  slug: string;
  name: string;
  shortName: string;
  description: string;
  requirements: string[];
  notes?: string;
}

export const RCF_CARRIERS: RcfCarrier[] = [
  {
    slug: "citizens",
    name: "Citizens Property Insurance",
    shortName: "Citizens",
    description: "Florida's state-run insurer of last resort — strictest roof certification requirements in the state.",
    requirements: [
      "Roof condition certificate dated within 12 months",
      "4-point inspection for homes 25+ years",
      "Wind mitigation (OIR-B1-1802) for any premium discount",
      "Roof must have 5+ years of useful life remaining",
    ],
    notes: "Citizens depopulation policies frequently demand a fresh certificate at renewal even for newer roofs.",
  },
  {
    slug: "universal-property",
    name: "Universal Property & Casualty",
    shortName: "Universal",
    description: "One of Florida's largest private homeowners carriers — accepts standard FL roof certification forms.",
    requirements: [
      "Roof certificate within 12 months",
      "4-point for homes 30+ years",
      "Wind mitigation accepted on OIR-B1-1802",
    ],
  },
  {
    slug: "heritage",
    name: "Heritage Property & Casualty",
    shortName: "Heritage",
    description: "Florida-domiciled carrier with active book in coastal counties — strict on roof age and condition.",
    requirements: [
      "Roof certificate within 12 months",
      "4-point for homes 25+ years",
      "Wind mitigation valid 5 years",
    ],
  },
  {
    slug: "tower-hill",
    name: "Tower Hill Insurance",
    shortName: "Tower Hill",
    description: "Long-standing Florida homeowners carrier — accepts standard certification packages.",
    requirements: [
      "Roof certificate within 12 months",
      "4-point for homes 30+ years",
      "Wind mitigation report on OIR-B1-1802",
    ],
  },
  {
    slug: "slide",
    name: "Slide Insurance",
    shortName: "Slide",
    description: "Newer Florida carrier (took over Farmers FL book) — modern digital underwriting workflow.",
    requirements: [
      "Roof certificate within 12 months",
      "4-point for homes 30+ years",
      "Wind mitigation on OIR-B1-1802",
    ],
  },
  {
    slug: "american-integrity",
    name: "American Integrity Insurance",
    shortName: "American Integrity",
    description: "Florida-based carrier with statewide footprint — common in Central and Southwest FL.",
    requirements: [
      "Roof certificate within 12 months",
      "4-point for homes 25+ years",
      "Wind mitigation valid 5 years",
    ],
  },
  {
    slug: "florida-peninsula",
    name: "Florida Peninsula Insurance",
    shortName: "Florida Peninsula",
    description: "Florida-focused homeowners carrier active across the I-95 corridor.",
    requirements: [
      "Roof certificate within 12 months",
      "4-point for homes 30+ years",
      "Wind mitigation on OIR-B1-1802",
    ],
  },
  {
    slug: "kin",
    name: "Kin Insurance",
    shortName: "Kin",
    description: "Direct-to-consumer Florida carrier with rapid digital binding.",
    requirements: [
      "Roof certificate within 12 months",
      "Wind mitigation report",
      "4-point for homes 25+ years",
    ],
  },
];

export const findRcfCarrier = (slug: string) =>
  RCF_CARRIERS.find(c => c.slug === slug);
